<div *ngIf="{ workOrder: workOrder$ | async } as data" id="body-report-container" class="print-body-report"
  (window:resize)="onResize($event)">
  <div fxLayout="column" fxLayoutAlign="center center" class="bg-white qcontainer mb-9">
    <div class="w-full grid">
      <div class="body-report-diagram flex justify-self-center sm:mt-2">
        <svg class="w-full h-full" (click)="draw($event)" cdkOverlayOrigin [class.disableDraw]="signatureSaved">
          <g *ngFor="let ele of inspectionService.bodyReportObject.bodyReportElements">
            <text [attr.x]="calculateX(ele.x,ele.source) - 10" [attr.y]="calculateY(ele.y,ele.source) - 25"
              class="mat-caption" style="font-weight: bold;">{{ele.type}}</text>
            <circle width="1px" height="1px" cdkOverlayOrigin [ngClass]="{'focus':ele.f===1}" [attr.fill]="ele.color"
              [attr.id]="ele.id" [attr.cx]="calculateX(ele.x,ele.source)" [attr.cy]="calculateY(ele.y,ele.source)"
              [attr.r]="calculateRadius(ele.r)" [attr.stroke-width]="ele.sw||sw">
            </circle>
          </g>
        </svg>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="hide-print">
        <mat-radio-group class="flex w-full place-content-between sm:max-w-1/2" aria-label="Select an option"
          [(ngModel)]="currentTool" [class.disableActiveTools]="signatureSaved" [disabled]="signatureSaved">
          <mat-radio-button *ngFor="let tool of tools" [value]="tool" aria-label="{{tool.name}}"
            style="margin-right:4px">
            <div fxLayout="row" fxLayoutAlign="center center">
              <div mat-list-icon class="type-icon" [class.crack]="tool.id == 2" [class.dent]="tool.id == 1"
                [class.scratch]="tool.id == 0" fxLayout="row" fxLayoutAlign="center center"
                (click)="currentTool = tool">
              </div>
              <span class="mat-body-2" style="margin-left:4px">{{tool.name}}</span>
            </div>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="pt-3">
      <mat-checkbox [(ngModel)]="inspectionService.bodyReportObject.vehicleDirty" [disabled]="signatureSaved">
        Vehicle is dirty and cannot be properly inspected</mat-checkbox>
    </div>
    <div class="flex flex-col w-full pt-3">
      <div class="font-medium">eSignature</div>
      <div class="spacing-container flex flex-col">
        <small>{{agreementClause}}</small>
        <div class="display-print h-auto w-full border border-black px-6 py-5 flex justify-center">
          <img src={{signature}} class="object-contain">
        </div>
        <div id="signature-container" class="hide-print w-full border border-solid" fxFlexAlign="center">
          <svc-signature-pad #sigPad [options]="signaturePadOptions" (onBeginEvent)="drawSignatureStart()"
            (onEndEvent)="drawSignatureComplete()">
          </svc-signature-pad>
        </div>
        <div class="hide-print flex flex-row justify-between my-2">
          <span class="primary pointer" (click)="clearSignature()">Clear</span>
          <span *ngIf="browserControlService.embeddedInXsellerator" [class.disabledSignatureSave]="signatureSaved"
            class="primary pointer" (click)="saveSignature()">{{signatureSaved? 'Saved': 'Save'}}</span>
        </div>
      </div>
    </div>
    <!-- <div>
      <div>
        <mat-list dense>
          <span matSubheader>Vehicle Damage List</span>
          <mat-list-item (click)=" selectElement(element)" *ngFor="let element of elements"
            ng-class="{'selected-list-item': element.id == selectedElement.id}">
            <img [src]="" matListAvatar alt="" [ngStyle]="{'background-color': element.color}" />
            <h3 matLine>{{ element.type }} {{element.id == selectedElement.id}}</h3>
            <h4 matLine>{{ formatSeverity(element) }}</h4>
            <p matLine>{{ element.comment }}</p>
            <button matButton class="md-icon-button md-secondary" aria-label="Menu" (click)="removeElement(element)">
              <mat-icon>delete</mat-icon>
            </button>
          </mat-list-item>
        </mat-list>
      </div>
    </div> -->
  </div>

  <div *ngIf="!browserControlService.embeddedInXsellerator"
    class="sticky hide-print bottom-4 mt-4 px-4 z-10 w-full rounded-md flex flex-row items-center justify-between bg-quorum-blue text-white h-11">
    <div class="flex flex-row space-x-6 sm:space-x-8 items-center">
      <div class="cursor-pointer flex" (click)="deleteBodyReport(data.workOrder)">
        <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.3125 2.125L4.71875 3H9.25L8.65625 2.125C8.625 2.0625 8.53125 2 8.4375 2H5.53125C5.4375 2 5.34375 2.0625 5.3125 2.125ZM9.90625 1.28125L11.0625 3H11.5H13H13.25C13.6562 3 14 3.34375 14 3.75C14 4.1875 13.6562 4.5 13.25 4.5H13V14C13 15.4062 11.875 16.5 10.5 16.5H3.5C2.09375 16.5 1 15.4062 1 14V4.5H0.75C0.3125 4.5 0 4.1875 0 3.75C0 3.34375 0.3125 3 0.75 3H1H2.5H2.90625L4.0625 1.28125C4.375 0.8125 4.9375 0.5 5.53125 0.5H8.4375C9.03125 0.5 9.59375 0.8125 9.90625 1.28125ZM2.5 4.5V14C2.5 14.5625 2.9375 15 3.5 15H10.5C11.0312 15 11.5 14.5625 11.5 14V4.5H2.5ZM5 6.5V13C5 13.2812 4.75 13.5 4.5 13.5C4.21875 13.5 4 13.2812 4 13V6.5C4 6.25 4.21875 6 4.5 6C4.75 6 5 6.25 5 6.5ZM7.5 6.5V13C7.5 13.2812 7.25 13.5 7 13.5C6.71875 13.5 6.5 13.2812 6.5 13V6.5C6.5 6.25 6.71875 6 7 6C7.25 6 7.5 6.25 7.5 6.5ZM10 6.5V13C10 13.2812 9.75 13.5 9.5 13.5C9.21875 13.5 9 13.2812 9 13V6.5C9 6.25 9.21875 6 9.5 6C9.75 6 10 6.25 10 6.5Z"
            fill="white" />
        </svg>
      </div>

      <div class="cursor-pointer flex" (click)="printBodyReport(data.workOrder)">
        <svg width="15" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.5 5.5H2V2.5C2 1.40625 2.875 0.5 4 0.5H11.1562C11.6875 0.5 12.1875 0.71875 12.5625 1.09375L13.4062 1.9375C13.7812 2.3125 14 2.8125 14 3.34375V5.5H12.5V3.34375C12.5 3.21875 12.4375 3.09375 12.3438 3L11.5 2.15625C11.4062 2.0625 11.2812 2 11.1562 2H4C3.71875 2 3.5 2.25 3.5 2.5V5.5ZM4 12V15H12V12H4ZM3.5 10.5H12.5C13.0312 10.5 13.5 10.9688 13.5 11.5H14.5V8.5C14.5 8.25 14.25 8 14 8H2C1.71875 8 1.5 8.25 1.5 8.5V11.5H2.5C2.5 10.9688 2.9375 10.5 3.5 10.5ZM13.5 13V15.5C13.5 16.0625 13.0312 16.5 12.5 16.5H3.5C2.9375 16.5 2.5 16.0625 2.5 15.5V13H1C0.4375 13 0 12.5625 0 12V8.5C0 7.40625 0.875 6.5 2 6.5H14C15.0938 6.5 16 7.40625 16 8.5V12C16 12.5625 15.5312 13 15 13H13.5Z"
            fill="white" />
        </svg>
      </div>
    </div>

    <div class="flex flex-row space-x-3 sm:space-x-4 items-center">
      <div class="flex flex-row space-x-2 items-center" *ngIf="bodyReportUnsaved">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.6415 17.3774" width="19" class="w-4 sm:w-5">
          <path style=" fill: #ffc800; stroke-width: 0px;"
            d="m19.4037,16.5L10.3103.75c-.1924-.3333-.6736-.3333-.866,0L.3511,16.5c-.1924.3333.0482.75.433.75h18.1866c.3849,0,.6254-.4167.433-.75ZM10.9513,4.3636l-.1875,8.2159h-1.8296l-.1818-8.2159h2.1989Zm-.0284,11.142c-.1136.1895-.2652.3409-.4546.4545-.1856.1099-.392.1648-.6193.1648-.3447,0-.6402-.1212-.8864-.3636-.2424-.2425-.3636-.5379-.3636-.8864,0-.3409.1212-.6326.3636-.875.2462-.2424.5417-.3636.8864-.3636.3371,0,.6288.1212.875.3636.25.2424.375.5341.375.875,0,.2311-.0587.4413-.1761.6307Z" />
        </svg>
        <span class="mt-0 sm:mt-1 text-xs sm:text-sm">Unsaved Changes</span>
      </div>

      <div (click)="saveBodyReport(data.workOrder)"
        class="bg-white text-quorum-blue rounded-md py-1 px-2.5 flex flex-row items-center cursor-pointer">
        <svg class="mt-0.5" width="14" height="14" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.375 1.875V10.625C1.375 11.1172 1.75781 11.5 2.25 11.5H11C11.4648 11.5 11.875 11.1172 11.875 10.625V3.92578C11.875 3.67969 11.7656 3.46094 11.6016 3.29688L9.57812 1.27344C9.46875 1.16406 9.35938 1.10938 9.25 1.05469V3.625C9.25 4.11719 8.83984 4.5 8.375 4.5H3.125C2.63281 4.5 2.25 4.11719 2.25 3.625V1C1.75781 1 1.375 1.41016 1.375 1.875ZM3.125 1V3.625H8.375V1H3.125ZM0.5 1.875C0.5 0.917969 1.26562 0.125 2.25 0.125H8.94922C9.41406 0.125 9.85156 0.316406 10.1797 0.644531L12.2305 2.69531C12.5586 3.02344 12.75 3.46094 12.75 3.92578V10.625C12.75 11.6094 11.957 12.375 11 12.375H2.25C1.26562 12.375 0.5 11.6094 0.5 10.625V1.875ZM7.9375 8C7.9375 7.53516 7.66406 7.125 7.28125 6.87891C6.87109 6.63281 6.35156 6.63281 5.96875 6.87891C5.55859 7.125 5.3125 7.53516 5.3125 8C5.3125 8.49219 5.55859 8.90234 5.96875 9.14844C6.35156 9.39453 6.87109 9.39453 7.28125 9.14844C7.66406 8.90234 7.9375 8.49219 7.9375 8ZM6.625 5.8125C7.39062 5.8125 8.10156 6.25 8.51172 6.90625C8.89453 7.58984 8.89453 8.4375 8.51172 9.09375C8.10156 9.77734 7.39062 10.1875 6.625 10.1875C5.83203 10.1875 5.12109 9.77734 4.71094 9.09375C4.32812 8.4375 4.32812 7.58984 4.71094 6.90625C5.12109 6.25 5.83203 5.8125 6.625 5.8125Z"
            fill="#0054A6" />
        </svg>
        <span class="ml-1.5">Save</span>
      </div>
    </div>
  </div>
</div>